export default "__VITE_ASSET__CcdHUoQJ__"